import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import {getCookieValue} from "../utils/getCookieValue";
import {useInertiaState} from "./Layout";
import {Alert} from "@material-ui/lab";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import dayjs from "dayjs";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {isToday} from "date-fns";
import Datepicker from "./Datepicker";
import {usePage} from "@inertiajs/inertia-react";
import DatepickerStatic from "./DatepickerStatic";

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const TimeSlots = React.memo(function ({ day, appointmentGroup, parcelService, partner_id, form, }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { products } = useFormState();
        const [timeslots, setTimeslots] = useState(null);
        const [error, setError] = useState(null);
        const { timeslotUrl } = useInertiaState();
        const { availableDays } = usePage().props;

        useEffect(() => {
            setTimeslots(null);
            if(!day) {
                if(availableDays.length > 0) {
                    form.change('day', availableDays[0]);
                }
                return;
            }
            fetch(timeslotUrl || route('appointment.timeslots'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    day,
                    appointmentGroup,
                    parcelService,
                    partner_id,
                })
            })
                .then(response => response.json())
                .then(response => {
                    if(!response.success) {
                        setError(response.errors[0])
                        return;
                    }
                    setTimeslots(response.data)
                    setError(null)
                })

        }, [day]);

        // if (!timeslots && !error) {
        //     return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        // }
        //
        // if (!!error) {
        //     return <Alert severity="error">{ error }</Alert>;
        // }

        return (
            <div className={'grid grid-cols-12 gap-12 w-full'}>
                <div className={'col-span-12 md:col-span-4'}>
                    <Field
                        name={'day'}
                        component={DatepickerStatic}
                        field={{
                            "name": "day",
                            "label": <Trans i18nKey="appointment.form.day">Day</Trans>,
                            "size": "half",
                            "type": "datepicker",
                            "required": true,
                            "preventWeekends": true,
                            shouldDisableDate: (date) => !availableDays.includes(dayjs(date).format('YYYY-MM-DD')),
                        }}
                    />
                </div>
                {
                    !day && (
                        <div className={'col-span-12 md:col-span-8'}>
                            <h3>
                                <Trans i18nKey="appointment.notAvailable">Unfortunately there are no open appointments available</Trans>
                            </h3>
                        </div>
                    )
                }
                {
                    !!day && (
                        <div className={'col-span-12 md:col-span-8'}>
                            <h3>
                                <Trans i18nKey="appointment.timeslots">Open appointments for </Trans> {dayjs(day, 'YYYY-MM-DD').format('DD.MM.YYYY')}:
                            </h3>
                            <Grid container spacing={3}>
                                {
                                    Array.isArray(timeslots) &&
                                    timeslots
                                        .map((item) =>
                                            <Grid item xs={12} sm={3} key={item.id}>
                                                <Field
                                                    name={'timeslot_id'}
                                                    type={'radio'}
                                                    value={String(item.id)}
                                                    //placeholder={field.placeholder}
                                                    component={RadioButton}
                                                    validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                                    field={{
                                                        label: item.display_name,
                                                        titel: dayjs(item.start_time).format('HH:mm') + ' - ' + dayjs(item.end_time).format('HH:mm'),
                                                        info: '',
                                                    }}
                                                />
                                            </Grid>,
                                        )
                                }
                            </Grid>
                            {
                                Array.isArray(timeslots) && timeslots.length === 0 && (
                                    <Alert severity="info">
                                        <Trans i18nKey="appointment.noOpenAppointments">No open appointments for this date</Trans>
                                    </Alert>
                                )
                            }
                        </div>
                    )
                }
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default TimeSlots;
